import React, { useEffect, useState } from 'react';
import Header from './Header';
import Dashboard from './Dashboard';
import { useWebSocket } from '../hooks/useWebSocket';

const CommandCenter = () => {
  const [data, setData] = useState(null);
  const ws = useWebSocket('ws://localhost:8004');

  useEffect(() => {
    if (ws) {
      ws.onmessage = (event) => {
        const message = JSON.parse(event.data);
        setData(message);
      };
    }
  }, [ws]);

  return (
    <div className="flex flex-col h-screen">
      <Header />
      <main className="flex-1 grid grid-cols-4 grid-rows-4 gap-4 p-4">
        <Dashboard data={data} />
      </main>
    </div>
  );
};

export default CommandCenter;